(function(angular) {
    'use strict';

    angular.module('aprima-facility-api').factory('FacilityVisitRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        FacilityVisitRepository
    ]);

    function FacilityVisitRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            getVisitNoteList: getVisitNoteList,
            getPdfByVisit: getPdfByVisit,
            getDocumentImageByVisit: getDocumentImageByVisit,
            getPdfsByVisits: getPdfsByVisits, 
            postUsageMetricUpdate: postUsageMetricUpdate,            
        };

        function getVisitNoteList(patientId) {
            var timing = AprimaAnalytics.startTiming('FacilityVisitRepository', 'api', 'getVisitNoteList');
            var restangular = AprimaRestangular.get('facility');
            return restangular.all('patients/' + patientId + '/query-visits')
                              .getList()
                              .finally(timing.stop);
        }

        function getPdfByVisit(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('FacilityVisitRepository', 'api', 'getPdfByVisit');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('patients/' + patientId + '/visit/' + visitId + '/pdf')
                              .get()
                              .finally(timing.stop);
        }

        function getPdfsByVisits(patientId, visitIds) {
            var timing = AprimaAnalytics.startTiming('FacilityVisitRepository', 'api', 'getPdfsByVisits');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('patients', patientId)
                              .one('visits/pdfs')
                              .get({
                                  visitIds: visitIds,
                              })
                              .finally(timing.stop);            
        }

        function getDocumentImageByVisit(patientId, visitId, requestSettings) {
            var timing = AprimaAnalytics.startTiming('FacilityVisitRepository', 'api', 'getDocumentImageByVisit');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('/patients/' + patientId + '/visit/' + visitId + '/image')
                              .get({
                                    height: requestSettings.height,
                                    width: requestSettings.width,
                                    page: requestSettings.page,
                              })
                              .finally(timing.stop);
        }

        function postUsageMetricUpdate(updateUsageMetricDto) {
            var timing = AprimaAnalytics.startTiming('FacilityVisitRepository', 'api', 'postUsageMetricUpdate');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one( 'usage-metric/metric-update')
                .customPOST(updateUsageMetricDto)
                .finally(timing.stop);
        }
    }
})(window.angular);